export enum UserErrors{
    NO_USER_FOUND = "no-user-found",
    WRONG_CREDENTIALS = "wrong-credentials",
    USERNAME_ALREADY_EXISTS = "username-already-exists",
}


export enum ProductErrors {
    NO_USERS_FOUND = "no-users-found",
    NO_PRODUCT_FOUND = "no-product-found",
    NO_AVAILABLE_MONEY = "no-available-money",
    NOT_ENOUGH_STOCK = "not-enough-stock",
  }